import FeedbackJail from "../components/feedback/FeedbackJail";
import Header from "../components/Header";
import GeneralFeedback from "../components/feedback/GenFeedback";
import { userFeedback, interview } from "../stores/userStore";

export default function Feedback() {
  console.log(`Interview from feedback component: ${interview()}`);
  return (
    <div class="page">
      <Header></Header>

      <div id="feedback-content" class="npnm">
        <div id="feedback-left-column">
          <FeedbackJail
            feedback={userFeedback().individual_feedback}
            ratings={userFeedback().ratings}
            questions={interview().questions}
          />
        </div>

        <div id="feedback-right-column">
          <GeneralFeedback
            ratings={userFeedback().ratings}
            feedback={userFeedback().general_feedback}
          />
        </div>
      </div>
    </div>
  );
}
